(function (angular) {
    'use strict';

    /**
     * Creates a new controller for the rebate Fast Track form upload receipts modal
     */
    angular
        .module('enervee.fastTrack')
        .controller('fastTrackUploadReceiptsModalCtrl', FastTrackUploadReceiptsModalController);

    FastTrackUploadReceiptsModalController.$inject = [
        '$uibModalInstance',
        'AnalyticsService',
        'initialScope',
        'FastTrackUploadReceiptsService',
        'RebatesService',
    ];
    function FastTrackUploadReceiptsModalController(
        $uibModalInstance,
        AnalyticsService,
        initialScope,
        FastTrackUploadReceiptsService,
        RebatesService
    ) {
        var vm = this;
        vm.dismissModal = dismissModal;
        vm.rebatedProducts = FastTrackUploadReceiptsService.getRebatedProducts();
        vm.submitClaim = submitClaim;
        vm.submittingReceipt = false;

        function dismissModal(reason) {
            $uibModalInstance.dismiss(reason || 'cancel');
            AnalyticsService.reportEvent('Upload Receipts Closed');
        }

        /**
         * Attempts to submit the claim form.
         * Any errors picked up on the backend will be displayed appropriately.
         */
        function submitClaim() {
            vm.submittingReceipt = true;

            FastTrackUploadReceiptsService.submitClaim().then(
                function success() {
                    var trackingData = {
                        process_type: 'fast track 2.0',
                        process_step: 'upload receipt',
                    };
                    RebatesService.trackIncentiveEngaged('Completed', trackingData, initialScope.products);
                    initialScope.switchViews('success-message');
                },
                function error(errors){
                    vm.errors = errors;
                }
            ).finally(function () {
                vm.submittingReceipt = false;
            });
        }
    }
})(angular);
